import { formatDateToKST } from '@/utils/parser';

export const getStatisticsCalendarSelectedDate = (date: Date) => {
  return formatDateToKST(date);
};

export const isStatisticsCalendarDateSelectable = (date: Date, activeStartDate: Date) => {
  return formatDateToKST(date).slice(0, 7) === formatDateToKST(activeStartDate).slice(0, 7);
};
